<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#FEDF89" />
    <path
      d="M21.09 21C21.3251 20.3317 21.7892 19.7681 22.4 19.4091C23.0108 19.0502 23.7289 18.9189 24.4272 19.0387C25.1255 19.1585 25.7588 19.5215 26.2151 20.0635C26.6713 20.6055 26.9211 21.2915 26.92 22C26.92 24 23.92 25 23.92 25M24 29H24.01M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z"
      stroke="#683928"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
